module.exports = __webpack_public_path__ + "static/img/1-1.3e4e3f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/eng/1-1.png
// module id = yPlB
// module chunks = 0